import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'soft-field-ok-lager-lagerplatz-list-view',
  imports: [],
  templateUrl: './lager-lagerplatz.list-view.html',
  styleUrls: ['./lager-lagerplatz.list-view.css'],
})
export class LagerLagerplatzListView implements FieldOkItemComponent<any> {
  readonly item = input<any>();
}
